import React from 'react';
import cx from 'classnames';

import Coin from 'components/Coin';
import EventTracking from 'lib/EventTracking';
import GroupMemberFamily from 'groups/components/GroupMemberFamily';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import TextWithGlyph from 'components/TextWithGlyph';
import UserAvatar from 'users/components/UserAvatar';

type Props = {
  student: any;
  orgUuid: string;
  disableStudent?: boolean;
  disableParent?: boolean;
  onParentAdd?: () => void;
};

function UnmatchedAvatar() {
  return (
    <Coin size="xxxlarge" border="percussion">
      <Text size="xxsmall" color="graphite">
        ?
      </Text>
    </Coin>
  );
}

export default class StudentIdListTableRow extends React.Component<Props, any> {
  render() {
    const { student, disableStudent, disableParent, onParentAdd, orgUuid } = this.props;
    const { user } = student;

    if (!user) {
      return (
        <tr key={student.studentId} className="StudentIdListTable-row--unmatched">
          <td>
            <MediaObject center gutter="xsmall">
              <UnmatchedAvatar />
              <Text color="graphite">Unidentified</Text>
            </MediaObject>
          </td>
          <td>
            <TextWithGlyph
              weight="semibold"
              glyph="caution"
              glyphSize="medium"
              glyphColor="pencil"
              truncate
            >
              {student.studentId}
            </TextWithGlyph>
          </td>
          <td>
            <UnmatchedAvatar />
          </td>
        </tr>
      );
    }

    return (
      <tr key={user.uuid}>
        <td className={cx(disableStudent && 'StudentIdListTable-cell--disabled')}>
          <MediaObject center gutter="xsmall">
            <UserAvatar user={user} size="medium" />
            <span>{user.name}</span>
          </MediaObject>
        </td>
        <td className={cx(disableStudent && 'StudentIdListTable-cell--disabled')}>
          <Text truncate>{student.studentId}</Text>
        </td>
        <td className={cx(disableParent && 'StudentIdListTable-cell--disabled')}>
          <GroupMemberFamily
            userId={user.id}
            userUuid={user.uuid}
            directAddOptions={{ orgUuid }}
            familySummary={user.familySummary || { parents: [], children: [] }}
            canAddChild={false}
            canAddParent
            onAddFamilyMember={onParentAdd}
            staticProfilePicture
            addFamilyModalEventPrefix="announcements.target_by_student_id"
            addButtonOnClick={() =>
              EventTracking.trackKey(
                'announcements.target_by_student_id.list_of_uploaded_users.add_parent.click'
              )
            }
          />
        </td>
      </tr>
    );
  }
}
